import { ComponentsOverrides, Theme } from "@mui/material";

import borders from "@/themes/base/borders";
import boxShadows from "@/themes/base/boxShadows";
import colors from "@/themes/base/colors";
import pxToRem from "@/themes/functions/pxToRem";

const { grey, white } = colors;
const { borderRadius } = borders;
const { tabsBoxShadow } = boxShadows;

interface ITabs {
  styleOverrides: ComponentsOverrides<Theme>["MuiTabs"];
}

const tabs: ITabs = {
  styleOverrides: {
    root: {
      position: "relative",
      backgroundColor: grey![100],
      borderRadius: borderRadius.xl,
      minHeight: "unset",
      padding: pxToRem(4),
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: { overflow: "unset !important" },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: {
      height: "100%",
      borderRadius: borderRadius.lg,
      backgroundColor: white.main,
      boxShadow: tabsBoxShadow.indicator,
      transition: "all 500ms ease",
    },
  },
};

export default tabs;
